import * as React from "react";

function SvgRollbarIcon(props, ref) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 65 60" {...{ ...props, ref }}>
      <path
        d="M64 56.891V12.568c-.116-2.886-.193-7.28-6.651-4.65l-32.266 11.93c-8.081 3.174-16.942 6.66-21.498 23.675L-.001 56.895h10.262l2.899-10.817c3.264-12.185 9.675-14.703 15.527-17.005l25.385-9.415v37.237z"
        fill="#3a4757"
      />
      <g fillRule="evenodd">
        <path
          d="M24.8 33.864a16.267 16.267 0 00-2.982 2.09c-3.162 2.816-4.874 6.831-5.952 10.84l-2.703 10.091h11.64z"
          fill="#f7941e"
        />
        <path
          d="M37.762 28.595l-8.049 3.079-2.116.853V56.89h10.165z"
          fill="#bfd730"
        />
        <path d="M51.275 56.891v-33.24l-10.717 3.912v29.332z" fill="#00bad9" />
      </g>
    </svg>
  );
}

export default React.forwardRef(SvgRollbarIcon);
